export namespace Tooltip {
  export interface Config {
    element: HTMLElement;
    placement: 'top' | 'left' | 'right' | 'bottom';
  }
}
